var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { isFunction } from '../_internal/data';
import { useWindowWidth } from '../_internal/useWindowSize';
import { breakpoints } from '../breakpoints';
import { TogglePanel } from '../TogglePanel';
import { FloatingMenuContainer, FloatingMenu, FullScreenMenu, } from './Menu.style';
import { menuDefaultPositionSetter } from './Menu.utils';
export var Menu = React.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.fullScreenOnMobile, fullScreenOnMobile = _b === void 0 ? false : _b, _c = _a.position, position = _c === void 0 ? 'vertical-stretched' : _c, scrollable = _a.scrollable, _d = _a.setPosition, setPosition = _d === void 0 ? menuDefaultPositionSetter : _d, props = __rest(_a, ["children", "fullScreenOnMobile", "position", "scrollable", "setPosition"]);
    var width = useWindowWidth();
    var getChildren = React.useCallback(function (modal) {
        var content = isFunction(children) ? children(modal) : children;
        if (fullScreenOnMobile && width < breakpoints.raw.phone) {
            return React.createElement(FullScreenMenu, null, content);
        }
        return (React.createElement(FloatingMenuContainer, null,
            React.createElement(FloatingMenu, { "data-scrollable": scrollable }, content)));
    }, [children, fullScreenOnMobile, scrollable, width]);
    var setStyle = React.useCallback(function (dimensions, triggerDimensions) {
        return setPosition({
            triggerDimensions: triggerDimensions,
            menuHeight: dimensions.height,
            menuWidth: dimensions.width,
            position: position,
        });
    }, [position, setPosition]);
    return (React.createElement(TogglePanel, __assign({ children: getChildren, "data-testid": "menu-container", fullScreenOnMobile: fullScreenOnMobile, ref: ref, setStyle: setStyle }, props)));
});
//# sourceMappingURL=Menu.js.map